import React, { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NotifyForm = () => {
    const [email, setEmail] = useState("");
    const [state, setState] = useState("idle"); // idle | loading | success | error
    const [message, setMessage] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        if (!email || !email.includes("@")) {
            setState("error");
            setMessage("Please enter a valid email");
            return;
        }
        setState("loading");
        try {
            await axios.post(`${API}/notify`, { email, source: "coming_soon" });
            setState("success");
            setMessage("You're on the list. We'll bring the drop to you.");
            setEmail("");
        } catch (err) {
            setState("error");
            setMessage(
                err?.response?.data?.detail?.[0]?.msg ||
                    "Something went wrong. Try again shortly.",
            );
        }
    };

    return (
        <form
            onSubmit={submit}
            className="group relative w-full"
            data-testid="notify-form"
        >
            <div className="flex items-end gap-4 border-b border-ivory-100/40 pb-3 transition-colors focus-within:border-ivory-100">
                <label
                    htmlFor="notify-email"
                    className="sr-only"
                    data-testid="notify-label"
                >
                    Email
                </label>
                <input
                    id="notify-email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    placeholder="your@address.com"
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        if (state !== "idle") setState("idle");
                    }}
                    disabled={state === "loading"}
                    data-testid="notify-email-input"
                    className="w-full bg-transparent font-sans-body text-lg tracking-tight text-ivory-100 placeholder:text-ivory-100/40 focus:outline-none md:text-xl"
                />
                <motion.button
                    type="submit"
                    whileHover={{ x: 6 }}
                    whileTap={{ scale: 0.96 }}
                    disabled={state === "loading"}
                    data-testid="notify-submit-button"
                    className="shine-btn flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full border border-ivory-100/60 px-5 py-3 text-xs uppercase tracking-[0.3em] text-ivory-100 transition-colors hover:bg-ivory-100 hover:text-crimson-800"
                >
                    {state === "loading"
                        ? "Sending"
                        : state === "success"
                          ? "Added"
                          : "Notify Me"}
                    {state === "success" ? (
                        <Check size={14} />
                    ) : (
                        <ArrowRight size={14} />
                    )}
                </motion.button>
            </div>
            {message && (
                <p
                    className={`mt-3 text-xs uppercase tracking-[0.25em] ${state === "error" ? "text-red-300" : "text-ivory-100/70"}`}
                    data-testid="notify-message"
                >
                    · {message}
                </p>
            )}
            <p className="mt-3 text-[10px] uppercase tracking-[0.3em] text-ivory-100/40">
                We only email once — the day we launch.
            </p>
        </form>
    );
};

export default NotifyForm;
